import * as cx from 'classnames';
import * as React from 'react';
import { Suggestion } from 'react-places-autocomplete';
import * as Styles from './PlacesAutoCompleteDropdown.scss';

type GetSuggestionItemProps = <SuggestionProps extends {}>(suggestion: Suggestion, options?: SuggestionProps) => {
  key: number;
  id: string | null;
  role: 'option';
  onMouseEnter: () => void;
  onMouseLeave: () => void;
  onMouseDown: React.MouseEventHandler;
  onMouseUp: () => void;
  onTouchStart: () => void;
  onTouchEnd: () => void;
  onClick: (event?: any) => void;
} & SuggestionProps;

interface IOwnProps {
  loading: boolean;
  suggestions:  ReadonlyArray<Suggestion>;
  getSuggestionItemProps: GetSuggestionItemProps;
}

const PlacesAutoCompleteDropdown: React.SFC<IOwnProps> = ({ suggestions, loading, getSuggestionItemProps }) => {
  /* const suggestionsTest = [
    {
      id: '0',
      active: false,
      index: 0,
      description: 'plac Jana Pawła II, Wadowice, Poland',
      placeId: 'adfasdf',
      formattedSuggestion: {
        mainText: 'plac Jana Pawła II',
        secondaryText: 'Wrocław, Poland',
      },
      matchedSubstrings: [{ length: 1, offset: 0 }],
      terms: [{ offset: 0, value: 'São Paulo' }],
      types: ['sdg'],
    },
    {
      id: '1',
      active: false,
      index: 1,
      description: 'plac Jana Pawła II, Wadowice, Poland',
      placeId: 'adfasdf1',
      formattedSuggestion: {
        mainText: 'plac Jana Pawła',
        secondaryText: 'Wadowice, Poland',
      },
      matchedSubstrings: [{ length: 1, offset: 0 }],
      terms: [{ offset: 0, value: 'São Paulo1' }],
      types: ['sdg1'],
    },
    {
      id: '2',
      active: true,
      index: 2,
      description: 'plac Jana Pawła II, Wadowice, Poland',
      placeId: 'adfasdf1',
      formattedSuggestion: {
        mainText: 'Jana Pawła II',
        secondaryText: 'Warszawa, Poland',
      },
      matchedSubstrings: [{ length: 1, offset: 0 }],
      terms: [{ offset: 0, value: 'São Paulo1' }],
      types: ['sdg1'],
    },
    {
      id: '3',
      active: false,
      index: 3,
      description: 'plac Jana Pawła II, Wadowice, Poland',
      placeId: 'adfasdf1',
      formattedSuggestion: {
        mainText: 'plac Jana Pawła II',
        secondaryText: 'Wadowice, Poland',
      },
      matchedSubstrings: [{ length: 1, offset: 0 }],
      terms: [{ offset: 0, value: 'São Paulo1' }],
      types: ['sdg1'],
    },
  ]; */

  const contentClassNames = cx({
    [Styles.content]: true,
    [Styles.active]: suggestions.length > 0,
  });

  if (suggestions && suggestions.length === 0) { return null; }

  return (
    <div className={Styles.wrapper}>
      <div className={contentClassNames}>
        {/* loading && (
          <div className={Styles.suggestionItem}>
            <span className={Styles.text}>Fetching address...</span>
          </div>
        ) */}
        {suggestions.map(suggestion => {

          const suggestionItemClassNames = cx({
            [Styles.suggestionItem]: true,
            [Styles.active]: suggestion.active,
          });

          return (
            <div
              key={suggestion.id}
              {...getSuggestionItemProps(suggestion, {
                className: suggestionItemClassNames,
                id: suggestion.id,
              })}
            >
              <span className={Styles.text}>{suggestion.formattedSuggestion.mainText}</span>
              <span className={Styles.text}>{suggestion.formattedSuggestion.secondaryText}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PlacesAutoCompleteDropdown;
